/** @jsxImportSource @emotion/react */

import React from "react";
import { Button, toast } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { useDeleteAnnouncementMutation } from "~/graphql/supergraphHooks";
import { AnnouncementStatus } from "../types";
/** @jsxImportSource @emotion/react */

interface DeleteCellRendererProps {
  notificationId: number;
  notificationStatus: AnnouncementStatus;
}
const DeleteCellRenderer: React.FC<DeleteCellRendererProps> = ({
  notificationId,
  notificationStatus,
}) => {
  const canDelete = notificationStatus === "Active";
  const [deleteAnnouncementMutation] = useDeleteAnnouncementMutation({
    awaitRefetchQueries: true,
    onError: (e) => {
      toast.error(e.message);
      throw e;
    },
    refetchQueries: ["GetAnnouncements"],
  });

  /**
   * Handles what to do if the user exits without submitting a case.
   */
  const onDelete = async (notificationId: number) => {
    try {
      await deleteAnnouncementMutation({
        variables: {
          announcementId: notificationId,
        },
      });
      toast.success("announcement deleted!");
    } catch {
      // do nothing
    }
  };
  return (
    <Button
      css={{
        color: canDelete ? Colors.Danger500 : Colors.Neutral500,
      }}
      icon="trash"
      variant="muted"
      onClick={() => onDelete(notificationId)}
      disabled={!canDelete}
    ></Button>
  );
};

export default DeleteCellRenderer;
